import React, { useContext } from "react";
import { ArrowLeft } from "lucide-react";
import { Button, ButtonVariant } from "@merge-api/merge-javascript-shared";
import { FieldMappingModalStep } from "../../../../../../../models/Entities";
import FieldMappingModalContext from "../context/FieldMappingModalContext";

type FieldMappingModalBackButtonProps = {
  destinationStep: FieldMappingModalStep;
  onBeforeNavigate?: () => void;
};

const FieldMappingModalBackButton = ({
  destinationStep,
  onBeforeNavigate,
}: FieldMappingModalBackButtonProps) => {
  const { setModalStep } = useContext(FieldMappingModalContext);
  return (
    <Button
      variant={ButtonVariant.TextBlue}
      onClick={() => {
        onBeforeNavigate?.();
        setModalStep(destinationStep);
      }}
      leftIcon={<ArrowLeft size={16} />}
    >
      Back
    </Button>
  );
};

export default FieldMappingModalBackButton;
